// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  shareUrl:'https://uat.scancoupon.live/',

  production: true,
  firebaseConfig: {
    apiKey: "AIzaSyB_RI9DRr-oVWL42cVXXVz10lqWymITQts",
    authDomain: "authconnect-9a179.firebaseapp.com",
    projectId: "authconnect-9a179",
    storageBucket: "authconnect-9a179.firebasestorage.app",
    messagingSenderId: "998591135872",
    appId: "1:998591135872:web:b3d3e07128f847e60d6665",
    measurementId: "G-JN0V0N9V69"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
